const CATEGORY_DEFINITIONS = [
  {
    key: "earnings",
    label: "실적",
    categories: ["EARNINGS", "EARNING RELATED INFO"],
  },
  {
    key: "legal",
    label: "계약/법적",
    categories: ["LEGAL", "STOCK SPLIT", "MATERIAL AGREEMENT", "ACQUISITION/SALE", "DELIST RISK"],
  },
  {
    key: "dividend",
    label: "배당/자사주",
    categories: ["DIVIDEND", "REPURCHASE"],
  },
  {
    key: "board",
    label: "경영진/이사회",
    categories: ["BOARD/MANAGEMENT"],
  },
  {
    key: "others",
    label: "기타",
    categories: [],
  },
];

const formatDateLabel = (value) => {
  if (!value) return null;
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return null;
  const year = parsed.getFullYear();
  const month = String(parsed.getMonth() + 1).padStart(2, "0");
  const day = String(parsed.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const resolveCategoryKey = (item) => {
  const raw = String(item.category).toUpperCase();
  for (const def of CATEGORY_DEFINITIONS) {
    if (def.key === "others") continue;
    if (def.categories.includes(raw)) return def.key;
  }
  return "others";
};

const getNewsTimestamp = (item) => {
  const raw = item.reportdate;
  if (!raw) return 0;
  const parsed = new Date(raw);
  return Number.isNaN(parsed.getTime()) ? 0 : parsed.getTime();
};

const buildNewsMeta = (item) => {
  const source = item.company;
  const title = item.newstitle;
  const summary = item.newsmain;
  const body = item.newsmain;
  const category = item.category;
  const reportdate = item.reportdate;
  const dateLabel = formatDateLabel(item.reportdate);
  return {
    documentid: item.documentid,
    source,
    title,
    summary,
    body,
    category,
    categoryKey: resolveCategoryKey(item),
    reportdate,
    dateLabel,
    ticker: item.ticker,
    link: item.link,
    timestamp: getNewsTimestamp(item),
  };
};

const buildSnippet = (text, limit = 90) => {
  if (!text) return "";
  const normalized = String(text).replace(/\s+/g, " ").trim();
  if (normalized.length <= limit) return normalized;
  return `${normalized.slice(0, limit)}...`;
};

export {
  CATEGORY_DEFINITIONS,
  buildNewsMeta,
  buildSnippet,
};
